import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import { Modal, Button, styled } from "@mui/material/";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { FormControl, OutlinedInput, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import CardContent from "@mui/material/CardContent";

import { API_BASE_URL } from "../../../apiConfig"; //
import AddCoupon from "./AddCoupon";
import EditCoupon from "./EditCoupon";
import DeleteCoupon from "./DeleteCoupon";
import CouponModal from "./CouponModal";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";

const StyledCard = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  maxWidth: "1200px",
  maxHeight: "1400px",
  width: "97%",
  margin: "auto",
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 1400,
  maxHeight: 1400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

export default function ManageCoupon({ storeId, onClose }) {
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedCouponId, setSelectedCouponId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editCouponModalOpen, setEditCouponModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [addCouponModalOpen, setAddCouponModalOpen] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);
  const [couponIdToDelete, setCouponIdToDelete] = useState(null);
  const [nameToDelete, setNameToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [refreshFlag, setRefreshFlag] = useState(false);

  const fetchData = async (page, searchQuery) => {
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("Token not available. Please log in.");
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}Coupon/GetAllByPage/${
          page + 1
        }/${storeId}/${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.coupon && response.data.coupon.length > 0) {
        const formattedData = response.data.coupon.map((coupon) => ({
          id: coupon.id,
          storeID: coupon.storeID,
          couponTitle: coupon.couponTitle,
          couponDescription: coupon.couponDescription,
          couponCode: coupon.couponCode,
          affiliatelink: coupon.affiliatelink,
        }));

        setRows(formattedData);
        setTotalRecords(response.data.allRecord);
      } else {
        setRows([]);
        setTotalRecords(0);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          const response = await axios.get(
            `${API_BASE_URL}Coupon/GetAllByPage/${
              page + 1
            }/${storeId}/${searchQuery}`,
            {
              headers: {
                Authorization: `Bearer ${newToken}`,
              },
            },
          );

          if (response.data.coupon && response.data.coupon.length > 0) {
            const formattedData = response.data.coupon.map((coupon) => ({
              id: coupon.id,
              storeID: coupon.storeID,
              couponTitle: coupon.couponTitle,
              couponDescription: coupon.couponDescription,
              couponCode: coupon.couponCode,
              affiliatelink: coupon.affiliatelink,
            }));

            setRows(formattedData);
            setTotalRecords(response.data.allRecord);
          } else {
            setRows([]);
            setTotalRecords(0);
          }
        } catch (retryError) {
          console.error("Retry failed:", retryError);
          setRows([]);
          setTotalRecords(0);
        }
      } else {
        console.error("Error fetching data:", error);
        setRows([]);
        setTotalRecords(0);
      }
    }
  };

  const handlePaginationChange = (paginationModel) => {
    setCurrentPage(paginationModel.page);
  };

  const handleSearch = () => {
    //setCurrentPage(0);
    setTriggerSearch(!triggerSearch);
  };

  const handleClear = () => {
    setSearchValue("");
    //setCurrentPage(0);
    setTriggerSearch(!triggerSearch);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  useEffect(() => {
    fetchData(currentPage || 0, searchValue || "");
  }, [currentPage, triggerSearch, refreshFlag]);

  const handleDeleteClick = (id, name) => {
    setCouponIdToDelete(id);
    setNameToDelete(name);
    setShowConfirm(true);
  };

  const handleConfirmDelete = () => {
    const token = localStorage.getItem("token");

    axios
      .delete(`${API_BASE_URL}Coupon/Delete/${couponIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        alert("تم حذف الكوبون بنجاح.");
        setShowConfirm(false);
        setCouponIdToDelete(null);
        fetchData(currentPage, searchValue);
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          refreshTokenIfNeeded()
            .then((newToken) => {
              if (!newToken) {
                return navigate("/", { replace: true });
              }

              return axios.delete(
                `${API_BASE_URL}Coupon/Delete/${couponIdToDelete}`,
                {
                  headers: {
                    Authorization: `Bearer ${newToken}`,
                  },
                },
              );
            })
            .then(() => {
              alert("تم حذف الكوبون بنجاح.");
              setShowConfirm(false);
              setCouponIdToDelete(null);
              fetchData(currentPage, searchValue);
            })
            .catch((retryError) => {
              alert("Retry failed: " + retryError.message);
            });
        } else {
          console.error("Error deleting user:", error);
          alert("حدث خطأ أثناء محاولة حذف الكوبون.");
        }
      });
  };

  const refreshData = () => {
    // fetchData(currentPage, searchValue);
    setRefreshFlag((prev) => !prev);
  };

  const handleCancelDelete = () => {
    setShowConfirm(false);
    setCouponIdToDelete(null);
  };

  const handleEdit = (id) => {
    setSelectedCouponId(id);
    setEditCouponModalOpen(true);
  };

  const handleView = (id) => {
    setSelectedCouponId(id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCouponId(null);
  };

  const handleAddRow = () => {
    setAddCouponModalOpen(true);
  };

  const handleCloseAddLocationModal = () => {
    fetchData(currentPage, searchValue);
    refreshData();
    setAddCouponModalOpen(false);
  };

  const handleCloseEditLocationModal = () => {
    fetchData(currentPage, searchValue);
    refreshData();
    setEditCouponModalOpen(false);
  };

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const columns = [
    {
      field: "actions",
      headerName: "الإجراءات",
      flex: 1,
      renderCell: (params) => (
        <>
          <IconButton
            color="error"
            onClick={() =>
              handleDeleteClick(params.row.id, params.row.couponTitle)
            }
          >
            <DeleteIcon />
          </IconButton>
          <IconButton onClick={() => handleEdit(params.row.id)}>
            <EditIcon sx={{ color: "green" }} />
          </IconButton>
          <IconButton color="primary" onClick={() => handleView(params.row.id)}>
            <VisibilityIcon />
          </IconButton>
        </>
      ),
      headerAlign: "right",
      align: "right",
    },
    {
      field: "affiliatelink",
      headerName: "رابط افلييت",
      flex: 1,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "couponCode",
      headerName: "رمز الكود",
      flex: 1,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "couponDescription",
      headerName: "وصف الكوبون",
      flex: 1.5,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        const cleanText = stripHtml(
          params.row.couponDescription || "",
        ).substring(0, 100);
        return `${cleanText}...`;
      },
    },

    {
      field: "couponTitle",
      headerName: "عنوان الكوبون",
      flex: 3.5,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        const text = params.value;
        const isArabic = /[\u0600-\u06FF]/.test(text);
        const direction = isArabic ? "rtl" : "ltr";

        return (
          <div
            style={{
              direction: direction,
              textAlign: direction === "rtl" ? "right" : "left",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </div>
        );
      },
    },
  ];

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>
          <CardContent sx={{ textAlign: "right", mt: 2 }}>
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
              <OutlinedInput
                placeholder="ابحث بأ عنوان الكوبون"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={handleKeyDown}
                sx={{
                  color: "#5b5b5c",
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                  "& input": { color: "#303031" },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0064b7",
                  },
                }}
                endAdornment={
                  <InputAdornment position="end">
                    {searchValue && (
                      <IconButton onClick={handleClear}>
                        <ClearIcon />
                      </IconButton>
                    )}
                    <IconButton onClick={handleSearch}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: "1%",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddRow}
              >
                اضف كوبون
              </Button>
            </div>

            <Box
              dir="ltr"
              sx={{
                height: "67%",
                width: "100%",
              }}
            >
              <DataGrid
                style={{ background: "#f3f3f3" }}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.id}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 8,
                    },
                  },
                }}
                pageSizeOptions={[8]}
                paginationMode="server"
                rowCount={totalRecords}
                disableRowSelectionOnClick
                onPaginationModelChange={(model) => {
                  setIsLoading(true);
                  handlePaginationChange(model);
                  setIsLoading(false);
                }}
                disableColumnFilter={true}
                disableColumnSelector={true}
                disableColumnMenu={true}
                disableColumnSorting={true}
                autoHeight={true}
                localeText={{
                  noRowsLabel: "",
                }}
                sx={{
                  "& .MuiTablePagination-actions > button": {
                    transform: "rotate(180deg)",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    direction: "ltr",
                    textAlign: "right",
                  },
                  "& .MuiDataGrid-cell": {
                    direction: "ltr",
                    textAlign: "right",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    justifyContent: "flex-start",
                  },
                  "& .MuiTablePagination-toolbar": {
                    direction: "rtl",
                  },
                  "& .MuiDataGrid-cell:focus-within": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeader:focus-within": {
                    outline: "none",
                  },
                }}
              />
            </Box>
            {modalOpen && (
              <CouponModal id={selectedCouponId} onClose={handleCloseModal} />
            )}
            {addCouponModalOpen && (
              <AddCoupon
                storeId={storeId}
                onClose={handleCloseAddLocationModal}
                onSubmit={fetchData}
              />
            )}
            {editCouponModalOpen && (
              <EditCoupon
                storeId={selectedCouponId}
                onClose={handleCloseEditLocationModal}
                onSubmit={fetchData}
              />
            )}
            {showConfirm && (
              <DeleteCoupon
                onConfirm={handleConfirmDelete}
                onCancel={handleCancelDelete}
                couponTitle={nameToDelete}
              />
            )}
          </CardContent>
        </StyledCard>
      </Box>
    </Modal>
  );
}
